

jQuery(document).ready(function() {
  jQuery(window).scroll(function() {
    var sticky = jQuery('#header-component'),
    scroll = jQuery(window).scrollTop();
      if (scroll >= 100) sticky.addClass('fixed');
  else sticky.removeClass('fixed');
  });
});



document.addEventListener("click", function(e){
  if(e.target.closest("[data-sizechart-open]")){
    e.preventDefault();
    document.getElementById("sizechart-modal").classList.add("is-open");
    document.body.style.overflow = "hidden";
  }
  if(e.target.closest("[data-sizechart-close]") || e.target.classList.contains("sizechart-overlay")){
    document.getElementById("sizechart-modal").classList.remove("is-open");
    document.body.style.overflow = "";
  }
});

document.addEventListener("keydown", function(e){
  if(e.key === "Escape"){
    document.getElementById("sizechart-modal").classList.remove("is-open");
    document.body.style.overflow = "";
  }
});


document.addEventListener("click", function(e) {
  if (e.target.closest(".hidden-swatches__count")) {
    e.preventDefault();
    const fieldset = e.target.closest("fieldset");
    fieldset.querySelectorAll(".hidden-swatch").forEach(function(item){
      item.classList.remove("hidden-swatch");
    });
    e.target.closest(".more-swatches").remove();
  }
});



// jQuery(document).ready(function($){

//   function initRecommendationsSlider(){
//     var $slider = $('.product-recommendations .resource-list.resource-list--grid');
//     if ($slider.length && !$slider.hasClass('slick-initialized')) {
//       $slider.slick({
//         slidesToShow: 4,
//         slidesToScroll: 1,
//         appendArrows: $('.slider-arrows'),
//         prevArrow: `
//           <button type="button" class="slick-prev">
//             <svg width="30" height="30" viewBox="0 0 30 30" fill="none" style="height: 50%">
//               <path d="M7.17937 16.0708L20.6703 29.5571C21.2623 30.1476 22.2213 30.1476 22.8148 29.5571C23.4068 28.9667 23.4068 28.0076 22.8148 27.4171L10.394 15.0008L22.8133 2.5845C23.4053 1.99404 23.4053 1.03495 22.8133 0.443975C22.2213 -0.1465 21.2608 -0.1465 20.6688 0.443975L7.17788 13.9304C6.59489 14.5147 6.59489 15.4889 7.17937 16.0708Z" fill="white"></path>
//             </svg>
//           </button>
//         `,
//         nextArrow: `
//           <button type="button" class="slick-next">
//             <svg width="30" height="30" viewBox="0 0 30 30" fill="none" style="height: 50%">
//               <path d="M22.8206 13.9292L9.32971 0.442856C8.73774 -0.147619 7.77865 -0.147619 7.18519 0.442856C6.59322 1.03333 6.59322 1.99242 7.18519 2.58289L19.606 14.9992L7.18668 27.4155C6.59471 28.006 6.59471 28.9651 7.18668 29.557C7.77865 30.1475 8.73923 30.1475 9.3312 29.557L22.8221 16.0706C23.4051 15.4863 23.4051 14.5121 22.8206 13.9292Z" fill="white"></path>
//             </svg>
//           </button>
//         `,
//         arrows: true,
//         dots: false,
//         autoplay: true,
//         autoplaySpeed: 3000,
//         speed: 600,
//         cssEase: 'ease-in-out',
//         infinite: true,
//         responsive: [
//           { breakpoint:1191, settings: { slidesToShow: 3 }},
//           { breakpoint:800, settings: { slidesToShow: 3 }},
//           {
//             breakpoint:769,
//             settings: {
//               slidesToShow: 3,
//               dots: true,
//               arrows: false // hide arrows on mobile
//             }
//           },
//           { breakpoint:500, settings: { slidesToShow: 2, adaptiveHeight: true, dots: true, arrows: false }}
//         ]
//       });
//     }
//   }

//   initRecommendationsSlider();

//   const observer = new MutationObserver(function(mutations){
//     mutations.forEach(function(mutation){
//       if ($(mutation.addedNodes).find('.product-recommendations').length > 0 ||
//           $(mutation.target).hasClass('product-recommendations')) {
//         initRecommendationsSlider();
//       }
//     });
//   });

//   observer.observe(document.body, { childList: true, subtree: true });
// });

jQuery(document).ready(function($) {
  function footerAccordion() {
    if ($(window).width() < 993) {
      $('.shopify-section-group-footer-group .group-block.group-block--width-fill:nth-child(2) h4, .shopify-section-group-footer-group .group-block.group-block--width-fill:nth-child(3) h4')
        .off('click')
        .on('click', function() {
          var $this = $(this);
          var $accordion = $this.closest('.group-block-content').find('accordion-custom.menu');
          if ($accordion.length) {
            $accordion.slideToggle(300).toggleClass('acouve');
            $('.shopify-section-group-footer-group accordion-custom.menu').not($accordion).slideUp(300).removeClass('acouve');
            $this.toggleClass('acoive');
            $('.shopify-section-group-footer-group .group-block.group-block--width-fill h4').not($this).removeClass('acoive');
          }
        });
    } else {
      $('.shopify-section-group-footer-group .group-block.group-block--width-fill:nth-child(2) h4, .shopify-section-group-footer-group .group-block.group-block--width-fill:nth-child(3) h4').off('click').removeClass('acoive');
      $('.shopify-section-group-footer-group accordion-custom.menu').removeAttr('style').removeClass('acouve');
    }
  }
  footerAccordion();
  $(window).resize(function() {
    footerAccordion();
  });
});




